import { render } from "./facets.vue?vue&type=template&id=f9b2ac5e"
import script from "./facets.vue?vue&type=script&lang=js"
export * from "./facets.vue?vue&type=script&lang=js"

import "./facets.vue?vue&type=style&index=0&id=f9b2ac5e&lang=scss"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__